<template>
  <el-dialog
    title="付款记录"
    append-to-body
    :visible="dialogVisible"
    :close-on-click-modal="false"
    center
    width="80%"
    @close="closeDialog"
  >
    <div class="payRecord">
      <div>发货指令编号: {{ recordInstructionNo }}</div>
      <vxe-table
        width="100%"
        align="left"
        show-header-overflow
        class="vxe-table-element"
        :auto-resize="true"
        border
        resizable
        show-overflow
        :data="recordData"
        size="mini"
        ref="resultTable"
        :max-height="$store.state.app.tableHeight"
      >
        <vxe-table-column type="seq" width="50" title="序号"></vxe-table-column>
        <vxe-table-column field="applyPayNo" title="付款申请单编号"></vxe-table-column>
        <vxe-table-column field="applyPayDate" title="付款申请日期"></vxe-table-column>
        <vxe-table-column field="applyPayMoney" title="申请金额"></vxe-table-column>
        <vxe-table-column field="paidMoney" title="付款金额"></vxe-table-column>
        <vxe-table-column field="unPaidMoney" title="未付款金额"></vxe-table-column>
        <vxe-table-column field="payDate" title="付款日期"></vxe-table-column>
        <vxe-table-column field="receive" title="收款单位"></vxe-table-column>
        <vxe-table-column field="payNo" title="付款单号"></vxe-table-column>
      </vxe-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import API from '@/api/wareHouse/supplierDeliveryOrder.js';
  export default {
    name: 'recordDialog',
    props: ['dialogVisible', 'recordInstructionNo', 'businessInboundBatchNo'],
    data() {
      return {
        recordData: [],
      };
    },
    created() {
      if (this.businessInboundBatchNo) {
        this.getRecordData();
      }
    },
    methods: {
      closeDialog() {
        this.$emit('close');
      },
      getRecordData() {
        // let params = {
        //   inboundBatchNo: this.businessInboundBatchNo,
        // };
        this.$axios
          .post(`${API.PAYBATCH_BY_NO_API}/?inboundBatchNo=${this.businessInboundBatchNo}`)
          .then((res) => {
            console.log(res, '2222');
            if (res.data.code === 0) {
              this.recordData = res.data.data || [];
            }
          });
      },
    },
  };
</script>
